import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'telxl-attribute-tag',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgbTooltip],
    templateUrl: './attribute-tag.component.html',
    styleUrls: ['./attribute-tag.component.scss'],
    host: {
        '[class]': 'class || ""',
    },
})
export class TelXLAttributeTagComponent {
    name = input.required<string>();
    value = input.required<number>();
    tooltip = computed(() => `${this.name()} | ${this.value()}`);
}
